module.exports = __webpack_public_path__ + "img/apps.d8649578.svg";